// ----------------------------------------------------------------
// <copyright company="Microsoft Corporation">
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import * as Bowser from 'bowser';

export function isIE(): boolean {
    // https://stackoverflow.com/questions/9847580/how-to-detect-safari-chrome-ie-firefox-and-opera-browser/9851769
    /* tslint:disable */
    // @ts-ignore Internet Explorer 6-11
    return /*@cc_on!@*/false || !!document.documentMode;
}

export function isBrowserSupported(): boolean {
    return !isIE();
}

export function showBrowserWarning(): boolean {
    return !isBrowserMeetMinimumRequirements();
}

export function isBrowserMeetMinimumRequirements() {
    const browser = Bowser.getParser(window.navigator.userAgent);
    
    return !!browser.satisfies({
        chrome: '>1',
        edge: '>=18',
    });
}